import { render } from "./PageNotFound.vue?vue&type=template&id=1a4c65b6&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=1a4c65b6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4c65b6"]])

export default __exports__